import classNames from 'classnames'
import React from 'react'
import s from '../../fields.scss'
import {LabelProps} from './interfaces'

export const Label = ({classes, dataHook, required, htmlFor, caption, tabIndex = -1, id}: LabelProps) => (
  <label id={id} className={classNames(s.caption, classes)} data-hook={dataHook} tabIndex={tabIndex} htmlFor={htmlFor}>
    {required && <span aria-hidden="true">*</span>}
    {caption}
  </label>
)
